var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "18px", "font-weight": "600" } },
          [_vm._v(_vm._s(_vm.pageTitle))]
        ),
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
              [_vm._v(_vm._s(_vm.readonly ? "返回" : "取消"))]
            ),
            !_vm.readonly
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleSave }
                  },
                  [_vm._v("保存")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "max-width": "900px" },
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                disabled: _vm.readonly,
                "label-width": "110px"
              }
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("基本信息")
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "题目标题", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入题目标题" },
                            model: {
                              value: _vm.form.title,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "题目类型", prop: "questionTypeId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "选择题目类型" },
                              model: {
                                value: _vm.form.questionTypeId,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "questionTypeId", $$v)
                                },
                                expression: "form.questionTypeId"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "单选", value: 1 }
                              }),
                              _c("el-option", {
                                attrs: { label: "连线", value: 2 }
                              }),
                              _c("el-option", {
                                attrs: { label: "排序", value: 3 }
                              }),
                              _c("el-option", {
                                attrs: { label: "简答", value: 4 }
                              }),
                              _c("el-option", {
                                attrs: { label: "长文本", value: 5 }
                              }),
                              _c("el-option", {
                                attrs: { label: "多选", value: 6 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "技能维度" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "选择技能维度" },
                              model: {
                                value: _vm.form.skillDimension,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "skillDimension", $$v)
                                },
                                expression: "form.skillDimension"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "听力", value: "listening" }
                              }),
                              _c("el-option", {
                                attrs: { label: "阅读", value: "reading" }
                              }),
                              _c("el-option", {
                                attrs: { label: "看", value: "viewing" }
                              }),
                              _c("el-option", {
                                attrs: { label: "写作", value: "writing" }
                              }),
                              _c("el-option", {
                                attrs: { label: "综合", value: "comprehensive" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "布鲁姆层级" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "选择层级" },
                              model: {
                                value: _vm.form.bloomLevel,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "bloomLevel", $$v)
                                },
                                expression: "form.bloomLevel"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "记忆", value: "remember" }
                              }),
                              _c("el-option", {
                                attrs: { label: "理解", value: "understand" }
                              }),
                              _c("el-option", {
                                attrs: { label: "应用", value: "apply" }
                              }),
                              _c("el-option", {
                                attrs: { label: "分析", value: "analyze" }
                              }),
                              _c("el-option", {
                                attrs: { label: "评价", value: "evaluate" }
                              }),
                              _c("el-option", {
                                attrs: { label: "创造", value: "create" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "评判策略", prop: "scoringStrategy" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "选择评判策略" },
                              on: { change: _vm.onScoringStrategyChange },
                              model: {
                                value: _vm.form.scoringStrategy,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "scoringStrategy", $$v)
                                },
                                expression: "form.scoringStrategy"
                              }
                            },
                            _vm._l(_vm.SCORING_STRATEGY_OPTIONS, function(opt) {
                              return _c(
                                "el-option",
                                {
                                  key: opt.value,
                                  attrs: { value: opt.value, label: opt.label }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "line-height": "1.4",
                                        padding: "2px 0"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "font-weight": "600" }
                                        },
                                        [_vm._v(_vm._s(opt.label))]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "12px",
                                            color: "#909399"
                                          }
                                        },
                                        [_vm._v(_vm._s(opt.desc))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "策略说明" } }, [
                        _vm.currentStrategyDesc
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "min-height": "34px",
                                  padding: "7px 10px",
                                  "font-size": "12px",
                                  "line-height": "1.6",
                                  color: "#303133",
                                  background: "#f5f7fa",
                                  "border-radius": "4px",
                                  border: "1px solid #e4e7ed"
                                }
                              },
                              [_vm._v(_vm._s(_vm.currentStrategyDesc))]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  "min-height": "34px",
                                  padding: "7px 10px",
                                  "font-size": "12px",
                                  "line-height": "1.6",
                                  color: "#c0c4cc",
                                  background: "#f5f7fa",
                                  "border-radius": "4px",
                                  border: "1px dashed #dcdfe6"
                                }
                              },
                              [
                                _vm._v(
                                  "选择评判策略后，此处显示该策略的适用说明"
                                )
                              ]
                            )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("题目内容")
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "题目内容", prop: "question" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入题目内容"
                    },
                    model: {
                      value: _vm.form.question,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "question", $$v)
                      },
                      expression: "form.question"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "题目描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入题目描述（可选）"
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "图片" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("el-input", {
                      staticStyle: { flex: "1" },
                      attrs: { placeholder: "图片URL（可选）" },
                      model: {
                        value: _vm.form.pic,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pic", $$v)
                        },
                        expression: "form.pic"
                      }
                    }),
                    !_vm.readonly
                      ? _c(
                          "el-upload",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              accept: ".jpg,.jpeg,.png,.gif,.webp",
                              "before-upload": _vm.beforePicUpload
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  icon: "el-icon-upload2",
                                  "data-testid": "pic-upload-btn"
                                }
                              },
                              [_vm._v("上传图片")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.form.pic
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "8px",
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-image",
                          {
                            staticStyle: {
                              width: "120px",
                              height: "90px",
                              "border-radius": "4px",
                              border: "1px solid #DCDFE6",
                              cursor: "zoom-in"
                            },
                            attrs: {
                              "data-testid": "pic-preview",
                              src: _vm.form.pic,
                              "preview-src-list": [_vm.form.pic],
                              fit: "cover"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center",
                                  width: "100%",
                                  height: "100%",
                                  color: "#F56C6C",
                                  "font-size": "12px"
                                },
                                attrs: { slot: "error" },
                                slot: "error"
                              },
                              [_vm._v(" 图片加载失败 ")]
                            )
                          ]
                        ),
                        !_vm.readonly
                          ? _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "#F56C6C",
                                  "margin-left": "8px"
                                },
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-delete",
                                  "data-testid": "pic-remove-btn"
                                },
                                on: { click: _vm.handleRemovePic }
                              },
                              [_vm._v("移除")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("el-form-item", { attrs: { label: "音频" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("el-input", {
                      staticStyle: { flex: "1" },
                      attrs: { placeholder: "音频URL（可选）" },
                      model: {
                        value: _vm.form.audio,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "audio", $$v)
                        },
                        expression: "form.audio"
                      }
                    }),
                    !_vm.readonly
                      ? _c(
                          "el-upload",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              accept: ".mp3,.wav,.m4a,.ogg",
                              "before-upload": _vm.beforeAudioUpload
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  icon: "el-icon-upload2",
                                  "data-testid": "audio-upload-btn"
                                }
                              },
                              [_vm._v("上传音频")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.form.audio
                      ? _c("audio", {
                          ref: "audioPlayer",
                          staticStyle: { display: "none" },
                          attrs: { src: _vm.form.audio, preload: "none" },
                          on: { error: _vm.onAudioError }
                        })
                      : _vm._e(),
                    _vm.form.audio
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "el-button el-button--primary el-button--small",
                            staticStyle: { "margin-left": "8px" },
                            attrs: {
                              type: "button",
                              "data-testid": "audio-preview-btn"
                            },
                            on: { click: _vm.previewAudio }
                          },
                          [
                            _c("i", { staticClass: "el-icon-video-play" }),
                            _vm._v(" 播放")
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("答案配置")
              ]),
              _vm.hasOptions
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选项" } },
                    [
                      _vm._l(_vm.optionList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              "margin-bottom": "8px",
                              display: "flex",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  width: "30px",
                                  "font-weight": "600"
                                }
                              },
                              [_vm._v(_vm._s(_vm.optionLetters[index]) + ".")]
                            ),
                            _c("el-input", {
                              staticStyle: { flex: "1", "margin-right": "8px" },
                              attrs: { placeholder: "选项内容" },
                              model: {
                                value: _vm.optionList[index],
                                callback: function($$v) {
                                  _vm.$set(_vm.optionList, index, $$v)
                                },
                                expression: "optionList[index]"
                              }
                            }),
                            !_vm.readonly && _vm.optionList.length > 2
                              ? _c("el-button", {
                                  staticStyle: { color: "#F56C6C" },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeOption(index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      !_vm.readonly
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text", icon: "el-icon-plus" },
                              on: { click: _vm.addOption }
                            },
                            [_vm._v("添加选项")]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "正确答案", prop: "correctAnswer" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.hasOptions
                        ? "如：A 或 A,B"
                        : "请输入正确答案"
                    },
                    model: {
                      value: _vm.form.correctAnswer,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "correctAnswer", $$v)
                      },
                      expression: "form.correctAnswer"
                    }
                  }),
                  _vm.showReferencePreview
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#303133",
                            "line-height": "1.5",
                            "margin-top": "4px"
                          },
                          attrs: { "data-testid": "correct-answer-preview" }
                        },
                        [
                          _vm._v(
                            "展示效果：" + _vm._s(_vm.referenceAnswerPreview)
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "题目解析" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "题目解析（可选）"
                    },
                    model: {
                      value: _vm.form.explanation,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "explanation", $$v)
                      },
                      expression: "form.explanation"
                    }
                  })
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("关联知识点")
              ]),
              _c("el-form-item", { attrs: { label: "主知识点" } }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "360px" },
                      attrs: {
                        value: _vm.form.nodeId,
                        disabled: "",
                        placeholder: _vm.isEdit
                          ? "该题未绑定主知识点"
                          : "新建题目保存后再绑定知识点"
                      }
                    }),
                    _vm.nodePathText
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#606266",
                              "line-height": "1.6",
                              "margin-top": "4px"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.nodePathText) + " ")]
                        )
                      : _vm.isEdit
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#C0C4CC",
                              "margin-top": "4px"
                            }
                          },
                          [
                            _vm._v(
                              " 未绑定知识点，请回到题库列表页使用「知识点」按钮绑定 "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("题目难度")
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "难度档位", prop: "difficultyLevel" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      model: {
                        value: _vm.form.difficultyLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "difficultyLevel", $$v)
                        },
                        expression: "form.difficultyLevel"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "★ 基础（易）", value: "★" }
                      }),
                      _c("el-option", {
                        attrs: { label: "★★ 提高（中）", value: "★★" }
                      }),
                      _c("el-option", {
                        attrs: { label: "★★★ 拓展（难）", value: "★★★" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "12px",
                        "font-size": "12px",
                        color: "#909399"
                      }
                    },
                    [_vm._v("三星制，与知识图谱/小程序/抽题引擎对齐")]
                  )
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("其他")
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "草稿", value: "draft" }
                      }),
                      _c("el-option", {
                        attrs: { label: "已发布", value: "published" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }